import { Component, ViewEncapsulation } from '@angular/core';
import { Repository } from '../../../services/repository';
import 'jquery';
import 'bootstrap';

const swal = require('sweetalert');

@Component({
  selector: 'app-audit-lichsu-view',
  templateUrl: './auditlichsuview.component.html',
  styleUrls: ['./auditlichsuview.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [Repository]
})
export class auditlichsuviewComponent {
  title = 'Lịch sử thay đổi';
  rows: any[] = [];
  pageRows: any[] = [];
  listCurrentPage = 1;
  listPageSize = 20;
  listTotalPages = 0;
  listPages: any[] = [];
  detailHeader: any = null;
  detailRows: any[] = [];
  detailPageRows: any[] = [];
  detailCurrentPage = 1;
  detailPageSize = 20;
  detailTotalPages = 0;
  detailPages: any[] = [];
  snapshotPretty = '';
  modalId = 'modalAuditLichSuView_' + Math.random().toString(36).slice(2, 10);
  private lastPhanHeId: string = null;
  private lastRecordId: string = null;
  private lastTableName: string = null;

  constructor(private repo: Repository) { }

  /** Mở popup lịch sử theo chức năng + Id bản ghi. tableName tùy chọn khi 1 menu ghi nhiều bảng. */
  open(phanHeId: string, recordId: string | number, title?: string, tableName?: string) {
    if (!phanHeId || recordId === null || recordId === undefined || recordId === '' || recordId === 0 || recordId === '0') {
      swal('Thông báo!', 'Chỉ xem lịch sử khi bản ghi đã được lưu.', 'info');
      return;
    }
    this.title = title || 'Lịch sử thay đổi';
    this.lastPhanHeId = String(phanHeId);
    this.lastRecordId = String(recordId).toLowerCase();
    this.lastTableName = tableName || null;
    this.rows = [];
    this.pageRows = [];
    this.listCurrentPage = 1;
    this.detailHeader = null;
    this.detailRows = [];
    this.detailPageRows = [];
    this.snapshotPretty = '';

    $('#loading').show();
    const body: any = {
      PhanHeId: this.lastPhanHeId,
      RecordId: this.lastRecordId
    };
    if (tableName) body.TableName = tableName;
    this.repo.postRequest('api/auditlichsu/getbyrecord', body).subscribe(response => {
      $('#loading').hide();
      if (typeof response === 'string') {
        swal('Cảnh báo!', response, 'warning');
        return;
      }
      this.rows = Array.isArray(response) ? response : [];
      this.refreshListPage();
      this.showModalOnTop();
    }, () => {
      $('#loading').hide();
      swal('Lỗi!', 'Không tải được lịch sử.', 'error');
    });
  }

  refreshListPage() {
    const total = this.rows ? this.rows.length : 0;
    if (!this.listPageSize || this.listPageSize < 1) this.listPageSize = 20;
    this.listTotalPages = total > 0 ? Math.ceil(total / this.listPageSize) : 0;
    if (this.listCurrentPage < 1) this.listCurrentPage = 1;
    if (this.listTotalPages > 0 && this.listCurrentPage > this.listTotalPages)
      this.listCurrentPage = this.listTotalPages;
    const start = (this.listCurrentPage - 1) * this.listPageSize;
    this.pageRows = total > 0 ? this.rows.slice(start, start + this.listPageSize) : [];
    this.listPages = [];
    if (this.listTotalPages > 0) {
      const maxShow = 7;
      let pStart = Math.max(1, this.listCurrentPage - 3);
      let pEnd = Math.min(this.listTotalPages, pStart + maxShow - 1);
      pStart = Math.max(1, pEnd - maxShow + 1);
      for (let i = pStart; i <= pEnd; i++) this.listPages.push({ Id: i });
    }
  }

  setListPage(page: number) {
    if (page < 1 || (this.listTotalPages > 0 && page > this.listTotalPages)) return;
    this.listCurrentPage = page;
    this.refreshListPage();
  }

  onListPageSizeChange() {
    this.listCurrentPage = 1;
    this.refreshListPage();
  }

  /** Đưa modal lịch sử lên trên form danh mục (ng2-bs3-modal). */
  private showModalOnTop() {
    const $m = $('#' + this.modalId);
    if (!$m.length) return;
    if ($m.parent()[0] !== document.body) {
      $m.appendTo(document.body);
    }
    $m.addClass('audit-lichsu-modal');
    ($m as any).modal({ backdrop: true, keyboard: true, show: true });
    // Bootstrap stack backdrop: ép cao hơn modal danh mục (~1050).
    setTimeout(() => {
      $m.css('z-index', 2060);
      $('.modal-backdrop').last().addClass('audit-lichsu-backdrop').css('z-index', 2055);
    }, 0);
  }

  viewDetail(item: any) {
    $('#loading').show();
    this.repo.postRequest('api/auditlichsu/getdetail', { Id: item.Id })
      .subscribe(response => {
        $('#loading').hide();
        if (typeof response === 'string') {
          swal('Cảnh báo!', response, 'warning');
          return;
        }
        this.detailHeader = response.Header || null;
        this.detailRows = response.Details || [];
        this.detailCurrentPage = 1;
        this.refreshDetailPage();
        this.snapshotPretty = '';
        if (this.detailHeader && this.detailHeader.SnapshotJson) {
          try {
            this.snapshotPretty = JSON.stringify(JSON.parse(this.detailHeader.SnapshotJson), null, 2);
          } catch {
            this.snapshotPretty = this.detailHeader.SnapshotJson;
          }
        }
      }, () => {
        $('#loading').hide();
        swal('Lỗi!', 'Không tải chi tiết.', 'error');
      });
  }

  refreshDetailPage() {
    const total = this.detailRows ? this.detailRows.length : 0;
    if (!this.detailPageSize || this.detailPageSize < 1) this.detailPageSize = 20;
    this.detailTotalPages = total > 0 ? Math.ceil(total / this.detailPageSize) : 0;
    if (this.detailCurrentPage < 1) this.detailCurrentPage = 1;
    if (this.detailTotalPages > 0 && this.detailCurrentPage > this.detailTotalPages)
      this.detailCurrentPage = this.detailTotalPages;
    const start = (this.detailCurrentPage - 1) * this.detailPageSize;
    this.detailPageRows = total > 0 ? this.detailRows.slice(start, start + this.detailPageSize) : [];
    this.detailPages = [];
    if (this.detailTotalPages > 0) {
      const maxShow = 7;
      let pStart = Math.max(1, this.detailCurrentPage - 3);
      let pEnd = Math.min(this.detailTotalPages, pStart + maxShow - 1);
      pStart = Math.max(1, pEnd - maxShow + 1);
      for (let i = pStart; i <= pEnd; i++) this.detailPages.push({ Id: i });
    }
  }

  setDetailPage(page: number) {
    if (page < 1 || page > this.detailTotalPages) return;
    this.detailCurrentPage = page;
    this.refreshDetailPage();
  }

  onDetailPageSizeChange() {
    this.detailCurrentPage = 1;
    this.refreshDetailPage();
  }

  restore(item: any) {
    swal({
      title: 'Phục hồi?',
      text: item && item.MoTa ? item.MoTa : 'Phục hồi từ snapshot trong lịch sử.',
      icon: 'warning',
      buttons: ['Hủy', 'Phục hồi'],
      dangerMode: true
    }).then((ok: boolean) => {
      if (!ok) return;
      $('#loading').show();
      this.repo.postRequest('api/auditlichsu/restore', { Id: item.Id })
        .subscribe(response => {
          $('#loading').hide();
          if (typeof response === 'string') {
            swal('Cảnh báo!', response, 'warning');
            return;
          }
          swal('Thông báo!', (response && response.Message) || 'Phục hồi thành công.', 'success');
          this.detailHeader = null;
          this.detailRows = [];
          this.snapshotPretty = '';
          if (this.lastPhanHeId && this.lastRecordId) {
            this.open(this.lastPhanHeId, this.lastRecordId, this.title, this.lastTableName);
          }
        }, () => {
          $('#loading').hide();
          swal('Lỗi!', 'Không phục hồi được.', 'error');
        });
    });
  }
}
